

















import { Component, Vue } from 'vue-property-decorator'
@Component({
  name:'SupervisionMenu'
})
export default class SupervisionMenu extends Vue {
  private selectedKeys:any=[]
  private queryobj:any=[]
  private menuArr:any=[{
      title:'节能管理制度',
      path:'/energySupervision',
      id:1
    },{
      title:'生产工艺',
      path:'/manufacturTechnique',
      id:2
    },{
      title:'能源利用状况报告',
      path:'/energyUtilization',
      id:3
    },{
      title:'重点耗能设备信息',
      path:'/energyEquipment',
      id:4
    },{
      title:'计量器具配备信息',
      path:'/majorProductDatas',
      id:5
    },{
      title:'能源消费情况',
      path:'/EnergyConsumption',
      id:6
    }]

  private openView(menu:any) {
    if(menu.key==this.$route.path){
      return false
    }
    this.selectedKeys=[menu.key]
    this.$router.push({path:menu.key,query:this.queryobj})
  }
  handleRoute(){
      const curPath:string=this.$route.path
      this.queryobj=this.$route.query
      this.selectedKeys=[curPath]
    
  }
  created() {
    this.handleRoute()
  }
}
